export default [
  {
    name: "Transition",
    properties: [
      {
        name: "Transition",
        value: "transition",
        type: "text",
      },
      {
        name: "Property",
        value: "transition-property",
        type: 'text',
        autocomplete: ['none', 'all'],
        shorthand: 'transition',
      },
      {
        name: "Duration",
        value: "transition-duration",
        type: "number",
        shorthand: 'transition',
      },
      {
        name: "Timing Function",
        value: "transition-timing-function",
        type: ["text", 'function'],
        autocomplete: ['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear', 'step-start', 'step-end'],
        shorthand: 'transition',
      },
      {
        name: "Delay",
        value: "transition-delay",
        type: "number",
        shorthand: 'transition',
      },
    ]
  },
  {
    name: "Animation",
    properties: [
      {
        name: "Animation",
        value: "animation",
        type: "text",
      },
      {
        name: "Name",
        value: "animation-name",
        type: 'text',
        shorthand: 'animation',
      },
      {
        name: "Duration",
        value: "animation-duration",
        type: "number",
        shorthand: 'animation',
      },
      {
        name: "Timing Function",
        value: "animation-timing-function",
        type: ["text", 'function'],
        autocomplete: ['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear', 'step-start', 'step-end'],
        shorthand: 'animation',
      },
      {
        name: "Delay",
        value: "animation-delay",
        type: "number",
        shorthand: 'animation',
      },
      {
        name: "Iterations",
        value: "animation-iteration-count",
        type: "number",
        shorthand: 'animation',
      },
      {
        name: "Direction",
        value: "animation-direction",
        type: "text",
        autocomplete: ['normal', 'reverse', 'alterante', 'alternate-reverse'],
        shorthand: 'animation',
      },
      {
        name: "Fill Mode",
        value: "animation-fill-mode",
        type: "text",
        autocomplete: ['none', 'forwards', 'backwards', 'both'],
        shorthand: 'animation',
      },
      {
        name: "Play State",
        value: "animation-play-state",
        type: "text",
        autocomplete: ['paused', 'running'],
        shorthand: 'animation',
      },
      {
        name: "Offset",
        value: "offset",
        type: 'text',
      },
      {
        name: "Offset Path",
        value: "offset-path",
        type: 'text',
        shorthand: 'offset',
      },
      {
        name: "Offset Distance",
        value: "offset-distance",
        type: ['length', 'percentage'],
        shorthand: 'offset',
      },
      {
        name: "Offset Rotation",
        value: "offset-distance",
        type: ['text', 'angle'],
        autocomplete: ['auto', 'reverse'],
        shorthand: 'offset',
      },
      {
        name: "Offset Anchor",
        value: "offset-anchor",
        type: ["text", 'length', 'percentage'],
        autocomplete: ['top', 'right', 'bottom', 'left', 'center', 'auto'],
        shorthand: 'offset',
      },
      {
        name: "Will Change",
        value: "will-change",
        type: 'text',
        autocomplete: ['auto', 'scroll-position', 'contents'],
      },
    ]
  }
]